import React from 'react';
import { UserOutlined, LogoutOutlined } from '@ant-design/icons';
import { Avatar } from 'antd';
import { useNavigate } from "react-router-dom";
import {useToken} from "../context/TokenContext";


const DashBoardHeader = ({name}) => {
    const navigate = useNavigate();
    const [token, setToken] = useToken();

    const logout = () => {
        localStorage.removeItem("localData");
        setToken(null);
        navigate("/");
    }

    return (
        <div className='h-20 w-full flex justify-between items-center mobile:h-12 laptop:h-8'>
            <div className='flex justify-between items-center w-fit space-x-4 mobile:w-fit'>
                <Avatar size={50} icon={<UserOutlined />} />
                <div className='space-y-1 text-[#0987F3] text-start'>
                    <p className='text-lg font-semibold mobile:text-sm'>Тавтай морилно уу,</p>
                    <p className='text-xl font-bold mobile:text-sm'>{name}</p>
                </div>
            </div>
            <a className='flex justify-between items-center w-24 text-[#0987F3] text-xl cursor-pointer h-fit select-none mobile:text-lg mobile:w-[70px]' onClick={logout}>
                <div className='cursor-pointer'><LogoutOutlined twoToneColor={"blue"} /></div>
                <p>Гарах</p>
            </a>
        </div>
    );
}

export default DashBoardHeader;